<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" max-width="300" max-height="425">
        <template v-slot:activator="{props}">
            <v-text-field
                :model-value="touristsLabel"
                :single-line="singleLine"
                :outlined="outlined"
                variant="outlined"
                bg-color="white"
                :prepend-inner-icon="showIcon ? 'mdi-account' : null"
                hide-details
                readonly
                :class="{caption: $breakpoint.smAndDown}"
                :label="$t(token)"
                v-bind="props"
            />
        </template>
        <v-card color="white" theme="light" class="tourists-drop-down">
            <v-list density="compact">
                <v-list-item>
                    <tourists-select
                        :max-adults="maxAdults"
                        :max-children="maxChildren"
                        :max-total="maxTotal"
                        :_adults="adults"
                        :_children-ages="childrenAges"
                        @change-adults="adults = $event"
                        @change-children-ages="childrenAges = $event"
                    />
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import TouristsSelect from '~src/components/search/forms/touristsSelect.src'

    @Component({
        components: {
            TouristsSelect,
        },
    })
    export class TouristsSelectMenu extends Vue {
        @Prop({default: 'tourist'}) token
        @Prop({default: false}) outlined
        @Prop({default: true}) singleLine
        @Prop({default: ''}) label
        @Prop({default: true}) showIcon
        @Prop({default: 5}) maxAdults
        @Prop({default: 5}) maxChildren
        @Prop() maxTotal

        @Prop({default: 1}) _adults
        @Prop({default: () => []}) _childrenAges

        menu = false
        rooms = []

        @Emit()
        changeAdults(val) {
            return val
        }

        @Emit()
        changeChildrenAges(val) {
            return val
        }

        beforeUnmount() {
            this.$refs.menu.activatorNode = null
        }

        get touristsLabel() {
            const touristsTotal = this.adults + this.childrenAges.length
            return `${touristsTotal} ${this.$t(this.token, touristsTotal)}`
        }

        get adults() {
            return this._adults
        }

        set adults(val) {
            this.changeAdults(val)
        }

        get childrenAges() {
            return this._childrenAges
        }

        set childrenAges(val) {
            this.changeChildrenAges(val)
        }
    }

    export default TouristsSelectMenu
</script>

<style scoped lang="scss">
    @media (max-width: 960px) {
        .tourists-drop-down {
            max-width: 100% !important;
        }
    }

    :deep(.v-list-item__content) {
        overflow: visible;
    }
</style>
